import React, { useRef} from "react";
import { useDispatch, useSelector } from "react-redux";
import Box from '@mui/material/Box';
import Popover from '@mui/material/Popover';
import InputBase from '@material-ui/core/InputBase';
import { popupclose } from '../modules/popuptextstore';

export default function Popuptext(props) {

    const open = useSelector(state => state.popuptext.open);
    const key = useSelector(state => state.popuptext.key);
    const top = useSelector(state => state.popuptext.top);
    const left = useSelector(state => state.popuptext.left);
    const placeholder = useSelector(state => state.popuptext.placeholder);
    const defaultvalue = useSelector(state => state.popuptext.defaultvalue);
    const onApply = useSelector(state => state.popuptext.onApply);
    const textvalue = useRef(null);
    const dispatch = useDispatch();

    function onChange(e) {
        textvalue.current = e.target.value;
    }
    function onClose() {
        if (textvalue.current !== defaultvalue && textvalue.current !== null ) {
            onApply({ key:key, value:textvalue.current });
        }
        textvalue.current = null;
        dispatch(popupclose());
    }
    return (
        <Popover open={open} onClose={onClose}
            anchorReference="anchorPosition"
            anchorPosition={{ top: top, left: left }}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
        >
            <Box sx={{ border: 1, p: 1, bgcolor: 'background.paper' }}>
                <InputBase type="text" defaultValue={defaultvalue} placeholder={placeholder} onChange={onChange} autoFocus />
            </Box>
        </Popover>
    );
}